var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.667 22c.534-.534 1.068-1.068.574-4m-.574-2.666C7.334 10 8.334 9 8.667 8.667s1.333-1.333 6.667 0m-6.667 6.667c-5.333-1.334-6-.668-6.667-.001m6.667 0c5.333 1.334 6.333.333 6.666 0s1.334-1.333 0-6.666m6.667 0c-.667.667-1.333 1.333-6.666 0M15.333 2c-.534.534-1.068 1.068-.574 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaIcon);
export default __webpack_public_path__ + "static/media/dna-icon.e4d89e2c876ba397820fd61f851efdf9.svg";
export { ForwardRef as ReactComponent };